<template>
  <div class="couponList fvlw">
    <div v-for="item in couponList" :key="item.id">满{{ item.rightContent.fullNum }}条减{{ item.rightContent.subtractPrice }}</div>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const state = reactive({
      couponList: datas
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.couponList {
  div {
    font-size: 12px;
    padding: 1px 8px;
    margin-right: 8px;
    border-radius: 18px;
    border: 1px solid #3088c5;
    color: #3088c5;
    display: inline-block;
    margin-bottom: 8px;
  }
}
</style>
